const faviconImageTypes: Record<string, string> = {
  ico: 'image/x-icon',
  svg: 'image/svg+xml',
};

const faviconMimeType = (src: string) => {
  const ext = src.split('.').reverse()[0];

  return faviconImageTypes[ext];
};

/** @see https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Attributes/rel#icon */
export const faviconTag = (src?: string) => {
  if (!src) return {};

  return {
    href: src,
    rel: 'icon',
    tagName: 'link',
    type: faviconMimeType(src),
  };
};
